
import {
  Component
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import {
  SkyFlyoutInstance,
  SkyFlyoutService
} from '../../core';

import { FlyoutDemoContext } from './flyout-demo-context';
import { SkyFlyoutDemoInternalComponent } from './flyout-demo-internal.component';


export class SkyFlyoutDemoComponent {
  public users = Observable.of([
    { id: '1', name: 'Sally' },
    { id: '2', name: 'John' },
    { id: '3', name: 'David' },
    { id: '4', name: 'Janet' }
  ]);

  public flyout: SkyFlyoutInstance<SkyFlyoutDemoInternalComponent>;

  constructor(
    private flyoutService: SkyFlyoutService
  ) { }

  public openRecord(record: FlyoutDemoContext) {
    this.flyout = this.flyoutService.open(SkyFlyoutDemoInternalComponent, {
      providers: [{
        provide: FlyoutDemoContext,
        useValue: record
      }],
      ariaDescribedBy: 'my-describedby-id',
      ariaLabelledBy: 'my-labelledby-id',
      ariaRole: 'modal',
      defaultWidth: 500,
      maxWidth: 1000,
      minWidth: 200
    });

    this.flyout.closed.subscribe(() => {
      this.flyout = undefined;
    });
  }

  public closeFlyout() {
    this.flyout.close();
  }

  public removeFlyout() {
    this.flyoutService.close();
    this.flyout = undefined;
  }

  public isRecordOpen(record: FlyoutDemoContext): boolean {
    return (
      this.flyout &&
      this.flyout.componentInstance.context.id === record.id
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-flyout-demo',
  template: `<sky-list
  [data]="users"
  [defaultView]="grid">
  <sky-list-view-grid #grid>
    <sky-grid-column
      [locked]="true"
      [template]="customTemplate">
    </sky-grid-column>
    <sky-grid-column
      field="name"
      heading="Name"
      [locked]="true">
    </sky-grid-column>
  </sky-list-view-grid>
</sky-list>

<ng-template
  let-row="row"
  #customTemplate>
  <button
    type="button"
    class="sky-btn sky-btn-link"
    (click)="openRecord(row)">
    View record
  </button>
  <button
    *ngIf="isRecordOpen(row)"
    type="button"
    class="sky-btn sky-btn-default"
    title="Close record"
    (click)="closeFlyout()">
    <i class="fa fa-close" aria-hidden="true"></i>
  </button>
</ng-template>

<div *ngIf="flyout">
  <p>
    This button will close the flyout and then delete the host element from the document.
  </p>

  <button
    type="button"
    class="sky-btn sky-btn-default"
    (click)="removeFlyout()">
    <i class="fa fa-trash" aria-hidden="true"></i>
    Delete flyout
  </button>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyFlyoutService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
